const MeasureType = Object.freeze({
  MENTIONS: 'Mentions',
  POSTS: 'Posts',
  REPLIES: 'Replies',
  REPOSTS: 'Reposts',
  POST_VIDEOS: 'PostVideos',
  POST_IMAGES: 'PostImages',
  POST_OTHER: 'PostOther',
  IMPRESSIONS: 'Impressions',
  NET_SENTIMENT: 'NetSentiment',
  PASSION_INTENSITY: 'PassionIntensity',
  POSITIVES: 'Positives',
  NEGATIVES: 'Negatives',
  POSITIVE_ON_UNIQUE_AUTHORS: 'PositiveOnUniqueAuthors',
  NEGATIVE_ON_UNIQUE_AUTHORS: 'NegativeOnUniqueAuthors',
  NET_SENTIMENT_ON_UNIQUE_AUTHORS: 'NetSentimentOnUniqueAuthors',
  PASSION_INTENSITY_ON_UNIQUE_AUTHORS: 'PassionOnUniqueAuthors',

  POSITIVES_AND_NEGATIVES: 'PositivesAndNegatives',
  SOURCES: 'Sources',
  SOURCES_POSTS: 'SourcesPost',
  UNIQUE_AUTHORS: 'UniqueAuthors',
  OWNED: 'Owned',
  PARTNERED: 'Partnered',
  EARNED: 'Earned',
  TWITTER: 'Twitter',
  FACEBOOK: 'Facebook',
  INSTAGRAM: 'Instagram',
  YOUTUBE: 'YouTube',
  OTHER: 'Other',
  ENGAGEMENTS: 'Engagements',
  COMMENTS: 'Comments',
  LIKES: 'Likes',
  SHARES: 'Shares',
  DISLIKES: 'Dislikes',
  VIEWS: 'Views',
  SCORE: 'Score',
  ENGAGEMENT_RATIO: 'EngagementRatio',
  OVERALL_STAR_RATINGS: 'OverallStarRatings',
  OVERALL_SURVEY_SCORES: 'OverallSurveyScores',
  STAR_RATINGS: 'StarRatings',
  SURVEY_SCORES: 'SurveyScores',
  NET_PROMOTER_SCORES: 'NetPromoterScores',
  OVERALL_STAR_RATINGS_AVERAGE: 'OverallStarRatingsAverage',
  OVERALL_SURVEY_SCORES_AVERAGE: 'OverallSurveyScoresAverage',
  ENGAGEMENT_RATIO_ONLY: 'EngagementRatioOnly'
})
export default MeasureType
export type MeasureTypeStrings = typeof MeasureType[keyof typeof MeasureType]
// RESERVE BELOW
